module.exports = __webpack_public_path__ + "img/palacio_01.3bf2703f.jpg";